import { render, staticRenderFns } from "./IdentificationTypeManagement.vue?vue&type=template&id=1b59bcfa&scoped=true"
import script from "./IdentificationTypeManagement.vue?vue&type=script&lang=js"
export * from "./IdentificationTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./IdentificationTypeManagement.vue?vue&type=style&index=0&id=1b59bcfa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59bcfa",
  null
  
)

export default component.exports